export const CREATE_INVOICE = 'CREATE_INVOICE';
export const GET_INVOICES = 'GET_INVOICES';
export const GET_INVOICE = 'GET_INVOICE';
export const UPDATE_INVOICE = 'UPDATE_INVOICE';
export const DELETE_INVOICE = 'DELETE_INVOICE';
export const INVOICE_ERROR = 'INVOICE_ERROR';
